import { batch } from 'react-redux';

import { logApiError } from '../utils/log';

export const ADD_ERROR = 'ADD_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const REMOVE_ERROR = 'REMOVE_ERROR';
export const REMOVE_ERROR_BY_ROW_ID = 'REMOVE_ERROR_BY_ROW_ID';
export const ADD_FORM_HAS_FAILED_ENDPOINTS = 'ADD_FORM_HAS_FAILED_ENDPOINTS';
export const CLEAR_FAILED_ENDPOINTS_LIST = 'CLEAR_FAILED_ENDPOINTS_LIST';

export const addFormHasFailedEndpoints = ({ storeKey }) => ({
  type: ADD_FORM_HAS_FAILED_ENDPOINTS,
  payload: { storeKey },
});

export const clearErrors = (filter) => (dispatch) => {
  batch(() => {
    dispatch({
      type: CLEAR_FAILED_ENDPOINTS_LIST,
    });
    dispatch({
      type: CLEAR_ERRORS,
      filter,
    });
  });
};

export const addError = (error) => (dispatch) =>
  dispatch({
    ...error,
    type: ADD_ERROR,
  });

export const removeError = (error) => (dispatch) =>
  dispatch({
    type: REMOVE_ERROR,
    error,
  });

export const removeErrorByRowId = (errorRowId) => (dispatch) =>
  dispatch({ type: REMOVE_ERROR_BY_ROW_ID, rowID: errorRowId });

export const handleErrors = (errors, fullAdditionalProps = {}) => (dispatch) => {
  const { defaultMessage = '', ...additionalProps } = fullAdditionalProps;

  if (Array.isArray(errors)) {
    errors.forEach((error) => {
      if (!error.errorNumber) {
        logApiError(error.errorMessage);
      }

      const errorData = {
        ...additionalProps,
        hasFetchError: error.hasFetchError,
        code: error.errorNumber,
        message: error.errorMessage ?? error.errorMsg ?? defaultMessage,
      };

      if (error.rowID) {
        errorData.rowID = error.rowID;
      }

      if (error.columnName) {
        errorData.columnName = error.columnName;
      }

      dispatch(addError(errorData));
    });
  } else if (typeof errors === 'object' && errors !== null) {
    dispatch(
      addError({
        ...additionalProps,
        message: errors.message ?? defaultMessage,
        hasFetchError: errors?.hasFetchError,
      })
    );
  } else {
    dispatch(
      addError({
        ...additionalProps,
        message: errors || defaultMessage,
        hasFetchError: errors?.hasFetchError,
      })
    );
  }
};
